import React from 'react';

export const Conference = ({conferences}) => {
    return (
        <ul>
            {conferences.map((con, index) => (
                <li key={index}>
                    <span className="date">{con.year}</span><br/>
                    <span className="title">{con.title}</span><br/>
                    <span className="description">{con.description}</span>
                </li>
            ))}
        </ul>
    );
};